<img [src]="logoSrc" alt="Scenario University Logo" class="logo" />
<img [src]="avatarSrc" alt="User Avatar" class="avatar" />
